import { Environment } from "src/app/models/environment";

export const environment: Environment = {
    production: true,

    name: '#{ENVIRONMENT}#',
    version: '#{BUILD}#',

    multilingual: {
        defaultLang: 'EN',
        oneLinkApiKey: '#{ONE_LINK_KEY}#'
    },

    links: {
        bookingApp: '#{BSPA}#',
        jayrideHome: '#{JAYRIDEHOME}#',
    },

    auth0: {
        clientId: '#{AUTH0_CLIENT_ID}#',
        domain: '#{AUTH0_DOMAIN}#',
        audience: '#{AUTH0_BSPA_AUDIENCE}#'
    },

    jayrideApi: {
        url: '#{JAYRIDE_API}#'
    },

    cookieDomain: '#{COOKIE_DOMAIN}#'
}